module.exports = __webpack_public_path__ + "static/images/dialog-head-bg.89ead25.png";